import { render, staticRenderFns } from "./StoreCategory.vue?vue&type=template&id=86d2d3fc&scoped=true"
import script from "./StoreCategory.vue?vue&type=script&lang=js"
export * from "./StoreCategory.vue?vue&type=script&lang=js"
import style0 from "./StoreCategory.vue?vue&type=style&index=0&id=86d2d3fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d2d3fc",
  null
  
)

export default component.exports